import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

export default function Loader() {
  return (
    <div className="my-[130px] mx-auto flex justify-center">
      <ScaleLoader height={70} width={10} color={"#1c75bc"} />
    </div>
  );
}
